export default "__VITE_ASSET__BXf8irK8__"